export default "__VITE_ASSET__Da32vJ6a__"